import { render, staticRenderFns } from "./Q5Edit.vue?vue&type=template&id=77611c56&scoped=true&"
import script from "./Q5Edit.vue?vue&type=script&lang=js&"
export * from "./Q5Edit.vue?vue&type=script&lang=js&"
import style0 from "./Q5Edit.vue?vue&type=style&index=0&id=77611c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77611c56",
  null
  
)

export default component.exports